export default "__VITE_ASSET__CXf0zNNx__"